//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  props: ['tagCount', 'confirm'],
  methods: {
    save: function save() {
      this.hide();
      this.confirm();
    }
  }
};